import { RootState } from '../reducers'

export const getPagination = (state: RootState) => state.global.pagination
